import type { DatasetsMutatorCreateDatasetProps } from "./datasets-mutator-create-dataset.type";

import { useDatasetObservationCreate } from "@/entities/dataset";

import { useDatasetsMutatorHandleMutate } from "../datasets-mutator.hook";

export const useDatasetsMutatorCreateDataset = ({
  sectionObservationId,
  mutatorItem,
  invalidateKeys,
}: DatasetsMutatorCreateDatasetProps) => {
  const { mutate, status } = useDatasetObservationCreate(sectionObservationId, {
    invalidateKeys,
  });

  const createDatasetUsingObservationId = () => {
    mutate(mutatorItem.variables);
  };

  useDatasetsMutatorHandleMutate({
    mutatorItems: [mutatorItem],
    mutationStatus: status,
    onMutateReady: () => createDatasetUsingObservationId(),
  });

  return null;
};
